import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=62ba5f37&scoped=true&"
import script from "./shortcut.vue?vue&type=script&lang=js&"
export * from "./shortcut.vue?vue&type=script&lang=js&"
import style0 from "./shortcut.vue?vue&type=style&index=0&id=62ba5f37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba5f37",
  null
  
)

export default component.exports